<script setup>
import { BCard, BCardBody, BCardTitle, BListGroup, BListGroupItem, BSpinner } from 'bootstrap-vue-next';
import { onMounted, ref } from 'vue';

import ErrorState from '~/common/components/ErrorState.vue';

const ITEMS = [
  { key: 'has_mr', label: 'Submit a merge request', anchor: '#code' },
  { key: 'has_note', label: 'Comment on an issue or merge request', anchor: '#plan' },
  { key: 'has_discord', label: 'Link Discord and post a message', anchor: '#discord-messages' },
  { key: 'has_forum', label: 'Link Forum and post', anchor: '#forum-posts' },
  { key: 'has_translation', label: 'Translate on Crowdin', anchor: '#translations' },
  { key: 'has_event', label: 'Submit an event', anchor: '#events' },
  { key: 'has_content', label: 'Publish content', anchor: '#content' },
];

const checklist = ref(null);
const loading = ref(true);
const error = ref(false);

onMounted(async () => {
  try {
    const response = await fetch('/api/v1/users/checklist');

    checklist.value = await response.json();
  } catch {
    error.value = true;
  } finally {
    loading.value = false;
  }
});
</script>

<template>
  <BCard no-body>
    <BCardBody class="pb-0">
      <BCardTitle>Your contribution checklist</BCardTitle>
      <BSpinner v-if="loading" />
      <ErrorState v-else-if="error" />
    </BCardBody>
    <BListGroup
      v-if="!loading && !error"
      flush
    >
      <BListGroupItem
        v-for="item in ITEMS"
        :key="item.key"
        :to="`/docs/user-guide${item.anchor}`"
        class="d-flex align-items-center gap-2"
      >
        <span :class="checklist?.[item.key] ? 'text-success' : 'text-muted'">
          {{ checklist?.[item.key] ? '\u2713' : '\u25cb' }}
        </span>
        {{ item.label }}
      </BListGroupItem>
    </BListGroup>
  </BCard>
</template>
